<template>
  <button
    @click="pushPage"
    class="flex items-center p-2 px-2 w-28 border rounded-md border-foundationGrey50 bg-foundationGreyG20"
  >
    <span>
      <img src="@/assets/svg/details-eye.svg" class="w-4" />
    </span>
    <span class="ml-1 text-xs text-foundationGrey900">
      {{ buttonText }}
    </span>
  </button>
</template>

<script>
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";
export default {
  components: {
    FlexWrapper,
  },
  props: {
    buttonText: {
      type: String,
      default: "View Details",
    },
    link: {
      type: String,
      default: "/business-details",
    },
    description: {
      type: String,
      default: "buttonText: Text to be displayed, link: Page to be routed",
    },
  },
  methods: {
    pushPage() {
      this.$router.push(this.link);
    },
  },
};
</script>

<style></style>
